module.exports = __webpack_public_path__ + "img/prostitute.f5fc8aec.jpg";